import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { HowItWorks } from '../components/HowItWorks';
import { BenefitsSection } from '../components/BenefitsSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen flex flex-col w-full bg-[#f5f1e8]" data-id="element-183">
      <main className="flex-grow w-full" data-id="element-184">
        <Hero data-id="element-185" />
        <ProblemSection data-id="element-186" />
        <SolutionSection data-id="element-187" />
        <HowItWorks data-id="element-188" />
        <BenefitsSection data-id="element-189" />
        <CTASection data-id="element-190" />
      </main>

      <Footer data-id="element-191" />
    </div>;
}